const env = require("app/services/env");

function numberFormat(n, allowDecimalsForZero=false) {
  if (typeof n !== "number") {
      return null;
  }

  let numberOfDecimals = 2;
  let thousandSeparator = env.get('currency.thousand_separator');
  let decimalSeparator = env.get('currency.decimal_separator');
  let prefix = env.get('currency.prefix');
  let suffix = env.get('currency.suffix');

  let number = parseFloat(n);

  let numberString = number.toFixed(numberOfDecimals);

  if (numberOfDecimals > 0) {
    let decimalSeparatorIndex = numberString.indexOf(".");
    let decimalValue = numberString.substring(decimalSeparatorIndex + 1);
    numberString = numberString.substring(0, decimalSeparatorIndex);

    if (allowDecimalsForZero === true || parseInt(decimalValue) > 0) {
      numberString = numberString + decimalSeparator + decimalValue;
    }
  }

  numberString = numberString.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousandSeparator);

  return prefix + numberString + suffix;
}

module.exports = {
	numberFormat
};
